module.exports = __webpack_public_path__ + "static/media/cellular-automata.f74a7d8a.jpg";